<template>
  <VBlock
    class="reservation-wrapper"
    :direction="Direction.column"
    :sort="Sort.left_center"
    :padding="[0, 15, 20, 15]"
  >
    <VRadioBox
      class="immediate-button"
      name="reservation"
      value="immediate"
      :state="!deliveryReservation.use ? 'immediate' : ''"
      :onChecked="() => onClickDeliveryMethod(false)"
    >
      <VSpan class="text" text="지금 받기" :size="14" :color="TextColor.dartGray" :spacing="-0.35" />
    </VRadioBox>
    <VRadioBox
      :class="['reservate-label', isEmptyOptions && 'reservate-label-inactive']"
      name="reservation"
      value="reservate"
      :state="deliveryReservation.use ? 'reservate' : ''"
      :onChecked="onClickDeliveryReservation"
      :disabled="!availableDeliveryReservation"
    >
      <VBlock class="reservate-wrapper" :sort="Sort.space_between">
        <VSpan
          class="text"
          text="나중에 받기"
          :size="14"
          :spacing="-0.35"
          :color="!availableDeliveryReservation ? TextColor.disable : TextColor.darkGray"
        />
        <VSpan
          v-show="deliveryReservation.use"
          class="text date"
          :text="!deliveryReservation.selected.from ? '' : `${deliveryReservation.selected.from} ~ ${deliveryReservation.selected.to}`"
          :size="14"
          :color="TextColor.gray2"
          :spacing="-0.3"
        />
        <VA
          v-show="deliveryReservation.use && !!deliveryReservation.selected.from"
          :onClick="onClickDeliveryReservation"
        >
          <VSpan text="시간 변경" :color="TextColor.brand" :size="14" />
        </VA>
      </VBlock>
    </VRadioBox>
    <VSpan
      class="info-text"
      :size="14"
      :text="availableDeliveryReservation ? '나중에 받기는 오늘 중에만 가능합니다' : '오늘 예약이 마감되었습니다'"
      :color="TextColor.gray2"
    />
  </VBlock>
</template>

<script>
import VSpan, { TextColor } from '../../atoms/VSpan/index'
import VRadioBox from '@/presentationals/v2/components/layouts/atoms/VRadioBox'

import VBlock, { Direction, Sort } from '../../molecules/VBlock/index'
import VA from '../../molecules/VA/index'

export default {
  name: 'PreOrderDeliveryReservation',
  components: { VA, VSpan, VBlock, VRadioBox },
  props: {
    deliveryReservation: {
      type: Object,
      required: true
    },
    availableDeliveryReservation: {
      type: Boolean,
      required: false
    },
    onChangeDeliveryReservation: {
      type: Function,
      required: true
    },
    onDeliveryReservation: {
      type: Function,
      required: true
    }
  },
  computed: {
    isEmptyOptions() {
      return this.deliveryReservation.options.length === 0
    }
  },
  data() {
    return {
      Direction,
      TextColor,
      Sort
    }
  },
  methods: {
    onClickDeliveryMethod(flag) {
      if (!this.availableDeliveryReservation) return

      this.onChangeDeliveryReservation({ use: flag })
    },
    onClickDeliveryReservation() {
      if (!this.availableDeliveryReservation) return
      if (this.isEmptyOptions) return

      this.onDeliveryReservation()
      this.onClickDeliveryMethod(true)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.reservation-wrapper {
  width: 100%;
  height: auto;
  // padding: 0 16px 16px 16px;
  box-sizing: border-box;

  .immediate-button {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
  }

  .reservate-label {
    width: 100%;
    height: auto;

    .reservate-wrapper {
      width: 100%;
      height: 24px;
      align-items: center;
    }
  }

  .reservate-label-inactive {
    color: $gray-3 !important;
  }

  .info-text {
    margin-top: 5px;
    padding-left: 28px;
    letter-spacing: -0.35px;
  }

  .text {
    vertical-align: middle;
    line-height: 1;
  }
}

@media screen and (max-width: 330px) {
  .reservation-wrapper {
    .reservate-label {
      width: 100%;
      height: auto;

      .reservate-wrapper {
        width: 100%;
        height: 24px;
        align-items: center;

        .date {
          font-size: 12px !important;
        }
      }
    }
  }
}
</style>
